// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c5d0a016","27":"ef61b26e","80":"306f3658","198":"d7456358","223":"a42ccd9e","254":"dd912c17","364":"2668bdbe","394":"6777a25c","467":"da224daa","540":"00cefc2c","628":"f0a7e76c","644":"dcbdc8db","670":"9ddd78a2","791":"93850784","795":"9be9d7ed"}[chunkId] + ".chunk.js";
};